import { useAuth0 } from 'app/Auth'
import axios from 'axios'
import { useMutation } from 'react-query'

interface CreatePrefCardParams {
  surgeon_id: string
  procedure_type: string
  card_details: Record<string, any>
  name: string
}

interface CreatePrefCardResponse {
  message: string
}

export const useCreatePrefCard = () => {
  const { getAccessToken } = useAuth0()
  const REPORTS_URL = process.env.REACT_APP_REPORTS_URL

  const mutation = useMutation<
    CreatePrefCardResponse,
    Error,
    CreatePrefCardParams
  >(async (data: CreatePrefCardParams) => {
    const token = await getAccessToken()
    try {
      const response = await axios.post(
        `${REPORTS_URL}api/v1/preference_cards`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return response.data
    } catch (error) {
      throw error
    }
  })

  return mutation
}
